export const bannerImages = [
  "https://s3.ap-south-1.amazonaws.com/www.satnamsatsang.com/banners/banner1.jpg",
  "https://s3.ap-south-1.amazonaws.com/www.satnamsatsang.com/banners/banner2.jpg",
  "https://s3.ap-south-1.amazonaws.com/www.satnamsatsang.com/banners/banner3.jpg"
];

export const ashramLocations = [
  {
    title: "Mahendergarh Ashram",
    name: "Satnam Satsang Balana",
    address: "Satnali - Mahendergarh Rd, Balana, Haryana 123029",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14053.90184536197!2d76.0517068!3d28.2839179!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xd693d79e65a26d70!2sSatnam%20Satsang%20Balana!5e0!3m2!1sen!2sin!4v1616218293347!5m2!1sen!2sin"
  },
  {
    title: "Mukundgarh Ashram",
    name: "Satnam Satsang. Dera Baba Sh. Nekidas Ji Maharaj",
    address: "State Highway 8 By-Pass Road, Balriya, Mukundgarh, Rajasthan 333705",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14100.33198168603!2d75.2460946!3d27.9301008!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x503cc379c18f9fb!2sSatnaam%20Satsang.%20Dera%20Baba%20Sh%20.%20Nekidas%20Ji%20Maharaj!5e0!3m2!1sen!2sin!4v1616217952418!5m2!1sen!2sin"
  }
];

export const getAshramLocations = (settings = {}) => ashramLocations.map((location, index) => {
  const prefix = index === 0 ? "mahendergarhAshram" : "mukundgarhAshram";
  return {
    title: settings[`${prefix}Title`] || location.title,
    name: settings[`${prefix}Name`] || location.name,
    address: settings[`${prefix}Address`] || location.address,
    mapUrl: settings[`${prefix}MapUrl`] || location.mapUrl
  };
});

const galleryImages = [
  { imageUrl: "/gallery/satnam-gallery-01.jpg", caption: "Satnam Satsang spiritual lineage" },
  { imageUrl: "/gallery/satnam-gallery-02.jpg", caption: "Satnam Satsang remembrance" },
  { imageUrl: "/gallery/satnam-gallery-03.jpg", caption: "Satnam Satsang gallery photo 3" },
  { imageUrl: "/gallery/satnam-gallery-04.jpg", caption: "Satnam Satsang gallery photo 4" },
  { imageUrl: "/gallery/satnam-gallery-05.jpg", caption: "Satnam Satsang gallery photo 5" },
  { imageUrl: "/gallery/satnam-gallery-06.jpg", caption: "Satnam Satsang gallery photo 6" },
  { imageUrl: "/gallery/satnam-gallery-07.jpg", caption: "Satnam Satsang gallery photo 7" },
  { imageUrl: "/gallery/satnam-gallery-08.jpg", caption: "Satnam Satsang gallery photo 8" },
  { imageUrl: "/gallery/satnam-gallery-09.png", caption: "Satnam Satsang gallery photo 9" }
];

export const sampleContent = {
  slides: [
    {
      id: "welcome",
      title: "Welcome to Satnam Satsang Ahmedabad",
      description: "A quiet space for satsang, simran and the companionship of seekers.",
      imageUrl: "/home-slider-01.jpg",
      objectPosition: "center 25%",
      desktopFit: "contain",
      ctaLabel: "Explore Satsang",
      ctaUrl: "/satsang",
      status: "published",
      enabled: true,
      order: 1
    },
    {
      id: "peace",
      title: "Experience Peace Through Satsang and Simran",
      description: "Come together in remembrance, reflection and loving service.",
      imageUrl: "/home-slider-02.jpg",
      objectPosition: "center 35%",
      desktopFit: "contain",
      ctaLabel: "Upcoming Programmes",
      ctaUrl: "/events",
      eventDate: "Every Sunday",
      status: "published",
      enabled: true,
      order: 2
    },
    {
      id: "listen",
      title: "Listen to Spiritual Discourses and Bhajans",
      description: "Carry sacred sound with you—at home, on the road, and in every moment.",
      imageUrl: "/home-slider-03.jpg",
      objectPosition: "center 45%",
      ctaLabel: "Listen Now",
      ctaUrl: "/audio",
      status: "published",
      enabled: true,
      order: 3
    }
  ],
  announcements: [],
  satsangPrograms: [],
  events: [],
  audio: [],
  videos: [],
  galleryAlbums: [
    {
      id: "satnam-gallery-2026",
      title: "Satnam Satsang Gallery",
      description: "Sacred memories, spiritual lineage and moments of remembrance.",
      date: "2026-07-27",
      category: "Satnam Satsang",
      coverImageUrl: galleryImages[0].imageUrl,
      imageUrl: galleryImages[0].imageUrl,
      images: galleryImages,
      status: "published"
    }
  ],
  dailyThoughts: [
    {
      id: "today",
      title: "Today’s Thought",
      description: "When the mind becomes quiet, gratitude becomes a way of seeing.",
      attribution: "Satnam Satsang",
      status: "published"
    }
  ],
  pages: [
    {
      id: "home",
      title: "Home page",
      description: "A peaceful space for satsang, simran, devotional music, spiritual discourses and loving service in Ahmedabad.",
      eyebrow: "Welcome",
      heading: "A place to pause, listen and return within.",
      body: `मनुष्य जीवन आध्यात्मिक विकास की सर्वोच्च अवस्था है। आत्मा की चेतना का केंद्र आँखों के पीछे तीसरे तिल में स्थित है, पर उसकी दिशा बाहर की ओर होने से मनुष्य संसार और शरीर में उलझा रहता है। वास्तव में हम शरीर या मन नहीं, बल्कि चेतन आत्मा हैं। आत्मा ही मन और शरीर को शक्ति देती है, लेकिन इच्छा, अहंकार और मोह के कारण तीनों एक-दूसरे से बँधे प्रतीत होते हैं।

सत्संग, संतों की संगति और नाम-अभ्यास से मन शुद्ध होता है। साधक अंतर्मुख होकर दिव्य ज्योति और शब्द-धुन का अनुभव करता है। शब्द आत्मा को शरीर और मन के बंधनों से मुक्त करके उसके वास्तविक धाम सच्चखण्ड तक पहुँचाता है।`,
      status: "published"
    },
    {
      id: "about",
      title: "About Satnam Satsang Ahmedabad",
      description: "A community devoted to satsang, simran, selfless service and the practice of carrying spiritual awareness into everyday life.",
      heroEyebrow: "Our story",
      heroTitle: "Rooted in remembrance. Open to everyone.",
      imageUrl: "/about-spiritual-master.png",
      eyebrow: "आध्यात्मिक सन्देश",
      heading: "आत्मा की यात्रा",
      body: `हमारा (मनुष्य) जीवन विकास की सीढ़ी का आखिरी डण्डा है। अभी हमारे MIND और जीवात्मा की बैठक आँखों के पीछे, नौ द्वारों के केन्द्र तीसरे तिल में है और इसकी दिशा बाहर, नीचे की ओर है। इसलिए हम इस जड़ संसार में स्थूल शरीर से काम कर रहे हैं। यदि हम इस तीसरे तिल से एक कदम ऊँचा रख दें, तो हम अंदर के आध्यात्मिक मण्डलों में प्रवेश कर जाएँगे।

हम यह शरीर और MIND नहीं हैं। ये दोनों हमसे, यानी आत्मा से, सत्ता पाकर कार्यान्वित होते हैं। लेकिन आत्मा, MIND और शरीर अति सूक्ष्म गाँठ से बँधे हुए हैं, जिसके कारण ये एक लगते हैं।

The real living entity is the soul. Mind in itself is inert and a reality of the second order. It is the soul that puts life into it, as also into the body. Here, in the material world, body, mind and soul (i.e. Surat & Nirat) are closely joined together by strong ties of desire and bound hard by the chains of egoism and delusion. It is the soul that lends them consciousness and power.

Shabd (Audible Life Stream) takes each to its source. Through this transport, the hard knot is unravelled and the soul gets free from the slavery of body and mind. Matter mixes with matter, the mind goes up to Brahm and gets absorbed there, and the soul flies higher up to Such-Khand and merges in that Highest Being, Sat-Purus.

सन्तों की संगत, सतसंग के प्रभाव और नाम के अभ्यास से हमारा MIND पवित्र हो जाता है, यानी हमारे खयाल ऊँचे होते जाते हैं। हम अंदर में जग रही दिव्य ज्योति और रूहानी संगीत के सम्पर्क में आ जाते हैं तथा अपनी चेतनता की गहराई में प्रवेश कर, अपने ही द्वारा अपने आपका, यानी चेतन आत्मा का, निज अनुभव कर लेते हैं।

शब्द, यानी वह मधुर संगीत जो परम चेतन परमात्मा के धुरधाम से आ रहा है, के जरिए हम परम चेतन परमात्मा में समाकर परम चेतन हो जाते हैं।`,
      sectionHeading: "चेतन आत्मा को परम चेतन परमात्मा के धुरधाम में पहुँचने के लिए स्थूल मण्डल से सच्चखण्ड तक पाँच मुख्य मंजिलों को पार करना पड़ता है:",
      listItems: `सूक्ष्म मण्डल | (सहस्रदल कँवल – ज्योत निरंजन – ज्योति स्वरूप भगवान)
कारण मण्डल | (त्रिकुटी, ओंकार या ब्रह्म का देश)
आध्यात्मिक मण्डल | (पारब्रह्म – रारंग – रारई या निरंकार का देश, जहाँ शब्द स्वयं अमृत है)
अति चेतन आध्यात्मिक मण्डल | (भंवर गुफा – सोहम् का देश)
परम चेतन आध्यात्मिक मण्डल | (सच्चखण्ड – परमपिता परमात्मा, यानी सतनाम का देश)`,
      status: "published"
    }
  ],
  websiteSettings: [
    {
      id: "general",
      organisationName: "Satnam Satsang Ahmedabad",
      shortDescription: "Sacred sound, shared stillness and loving service.",
      logoUrl: "/logo.png",
      address: "Mahendergarh, Haryana · Mukundgarh, Rajasthan",
      phone: "",
      email: "",
      website: "https://www.satnamsatsang.co.in",
      whatsapp: "",
      facebook: "https://www.facebook.com/satnamsatsangahemdabad/",
      instagram: "",
      youtube: "https://www.youtube.com/channel/UCQ_jrtXOsXaA8nyft9xCHMg",
      mahendergarhAshramTitle: ashramLocations[0].title,
      mahendergarhAshramName: ashramLocations[0].name,
      mahendergarhAshramAddress: ashramLocations[0].address,
      mahendergarhAshramMapUrl: ashramLocations[0].mapUrl,
      mukundgarhAshramTitle: ashramLocations[1].title,
      mukundgarhAshramName: ashramLocations[1].name,
      mukundgarhAshramAddress: ashramLocations[1].address,
      mukundgarhAshramMapUrl: ashramLocations[1].mapUrl,
      maintenanceMode: false,
      public: true
    }
  ]
};

export const translations = {
  en: {
    home: "Home", about: "About Us", satsang: "Satsang", events: "Events", audio: "Audio",
    videos: "Video", gallery: "Gallery", contact: "Contact Us", admin: "Admin Login",
    listen: "Listen now", viewAll: "View all", readMore: "Read more", language: "हिंदी",
    search: "Search", darkMode: "Dark mode", lightMode: "Light mode"
  },
  hi: {
    home: "मुखपृष्ठ", about: "हमारे बारे में", satsang: "सत्संग", events: "कार्यक्रम", audio: "ऑडियो",
    videos: "वीडियो", gallery: "गैलरी", contact: "संपर्क", admin: "व्यवस्थापक",
    listen: "अभी सुनें", viewAll: "सभी देखें", readMore: "और पढ़ें", language: "English",
    search: "खोजें", darkMode: "डार्क मोड", lightMode: "लाइट मोड"
  }
};
